import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import '@aws-amplify/ui-react/styles.css';
import TagManager from "react-gtm-module";
// import {ThemeProvider} from "@aws-amplify/ui-react";


const tagManagerArgs = {
  gtmId: process.env.REACT_APP_GOOGLE_TAG_MANAGER_ID,
}

if (!!process.env.REACT_APP_GOOGLE_TAG_MANAGER_ID) {
  TagManager.initialize(tagManagerArgs)
}


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/*<ThemeProvider theme={test1Theme}>*/}
      <App/>
    {/*</ThemeProvider>*/}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
